import { render } from "./DeleteModal.vue?vue&type=template&id=49604009"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/DeleteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49604009"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49604009', __exports__)) {
    api.reload('49604009', __exports__)
  }
  
  module.hot.accept("./DeleteModal.vue?vue&type=template&id=49604009", () => {
    api.rerender('49604009', render)
  })

}


export default __exports__